function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import { makeObservable, observable, action } from "mobx";
import { PATH_GET_FAQS } from "@/config/faq-config";
var FaqStore = /*#__PURE__*/function () {
  function FaqStore(rootStore) {
    _classCallCheck(this, FaqStore);
    _defineProperty(this, "rootStore", void 0);
    _defineProperty(this, "service", void 0);
    _defineProperty(this, "faqs", []);
    _defineProperty(this, "faqsFetched", false);
    _defineProperty(this, "message", {
      id: "",
      show: false,
      text: "",
      type: ""
    });
    this.rootStore = rootStore;
    this.service = rootStore.service;

    // @ts-ignore
    makeObservable(this, {
      message: observable,
      faqsFetched: observable,
      faqs: observable,
      fetchFaqs: action
    });
  }
  return _createClass(FaqStore, [{
    key: "fetchFaqs",
    value: function fetchFaqs(callback) {
      var _this = this;
      if (!this.faqsFetched) {
        this.rootStore.uiStore.handleSpinner(++this.rootStore.uiStore.numberCallback);
        this.service.doAjax("GET", PATH_GET_FAQS).then(function (response) {
          if (response.status === 200) {
            _this.faqs = response.data;
            _this.faqsFetched = true;
          }
          _this.rootStore.uiStore.handleSpinner(--_this.rootStore.uiStore.numberCallback);
          callback(response);
        }).catch(function (error) {
          if (error.response) {
            _this.rootStore.uiStore.handleSpinner(--_this.rootStore.uiStore.numberCallback);
            _this.rootStore.uiStore.addDangerMessage({
              "text": error.response.data
            });
          }
        });
      }
    }
  }]);
}();
export default FaqStore;